/**
 * Third-party brand marks for the source platforms. Brand identity colors, not UI semantic colors, so they are named
 * constants here (client-ui-standard §3: "the only exceptions are third-party brand marks, kept as named constants").
 */
export interface PlatformBrand {
  /** Two-letter (or glyph) mark drawn on the tile. */
  label: string;
  /** Tile background: the platform's brand color. */
  background: string;
  /** Opacity of the tile background (0-1); omitted = solid. */
  opacity?: number;
  /** Outlined tile (the X mark is near-black and needs an edge on dark surfaces). */
  outlined?: boolean;
}

/** Text color on every brand tile: white on the platform's brand fill. */
export const BRAND_MARK_COLOR = '#ffffff';

export const PLATFORM_BRANDS: Record<string, PlatformBrand> = {
  twitter: { label: '𝕏', background: '#1d1f23', outlined: true },
  x: { label: '𝕏', background: '#1d1f23', outlined: true },
  telegram: { label: 'TG', background: '#2aabee' },
  discord: { label: 'DC', background: '#5865f2' },
  farcaster: { label: 'FC', background: '#7c3aed' },
  reddit: { label: 'RD', background: '#ff4500', opacity: 0.9 },
  lens: { label: 'LN', background: '#00501e', opacity: 0.8 },
  youtube: { label: 'YT', background: '#ff0000', opacity: 0.8 },
  substack: { label: 'SS', background: '#ff6719', opacity: 0.8 },
};

/** `rgba()` of a `#rrggbb` brand color at the given opacity. */
export function brandBackground(brand: PlatformBrand): string {
  if (brand.opacity === undefined) return brand.background;
  const r = parseInt(brand.background.slice(1, 3), 16);
  const g = parseInt(brand.background.slice(3, 5), 16);
  const b = parseInt(brand.background.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${brand.opacity})`;
}
